// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".corporation-members[data-v-31dbaeae]{min-height:100%;border-top:1px solid #e2e2e2;border-bottom:1px solid #e2e2e2;background-color:#f5f5f5}.no-member[data-v-31dbaeae]{font-size:1.2rem;color:#101010;padding:2.5rem 1.5rem}@media screen and (min-width:560px){.no-member[data-v-31dbaeae]{padding:2.5rem 3rem}}@media screen and (min-width:960px){.no-member[data-v-31dbaeae]{width:70%;margin:0 auto;padding:2.5rem 0}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
